export const WSS_EVENT="wss_event";
export const EVENT_SCORE_UPDATED="event_score_updateed"; // {event_type:"event_score_updateed",data:{id:1,score:10}}

export const SESSION_SELECTED_TEAM="selected_team"
export const SESSION_QUESTIONS="questions"
export const SESSION_QUESTION_INDEX="question_index"